import React, { useEffect } from 'react';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 100,
    display: 'inline-block',
    marginLeft: 15,
    //overflow: 'hidden'
  }
}));

const SarasSlider2 = (props) => {
  const { steps, datalist, value, min, max, onChange } = props;

  const [selectedVal, setSelectedVal] = React.useState('0');

  const classes = useStyles();

  const initializeValue = () => {
    if (value && !isNaN(Number(value))) {
      setSelectedVal(selectedVal)
    }
  }

  useEffect(initializeValue, [value]);

  const onSelectionChange = (event, val) => {
    setSelectedVal(val)
    if (onChange) onChange(event, datalist[val])
  }

  const renderLabel = () => {
    let selectStep = datalist[value];
    if (selectStep.lbl)
      return (
        <label className={`uiPriority ${selectStep.class}`} >{selectStep.lbl}</label>
      )
  }

  return (
    <>
      {renderLabel()}
      <div className={classes.root}>
        <Slider
          defaultValue={value}
          aria-labelledby="discrete-slider-restrict"
          step={steps || null}
          marks={datalist}
          valueLabelDisplay="off"
          min={Number(min)}
          max={Number(max)}
          onChange={onSelectionChange}
        />
      </div>
    </>
  );
}

export default SarasSlider2